// DS4.8 - Slider Variant
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Slider, { DefaultPreviousButton, DefaultNextButton } from '@wix/da-ds/pkg/Slider';
import s from './FacetListRow.scss';
/**
 *
 * Included in da-shared-react because it relies on Slider
 */ const FacetListRow = (_param)=>{
    var { facets, className } = _param, sliderProps = _object_without_properties(_param, [
        "facets",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(Slider, _object_spread_props(_object_spread({}, sliderProps), {
        className: c(s['root'], className),
        contentClassName: s['content'],
        renderPrevButton: ({ onClick, className: prevButtonClassName })=>/*#__PURE__*/ React.createElement(DefaultPreviousButton, {
                onClick: onClick,
                className: c(prevButtonClassName, s['prev-button']),
                arrowSize: IconSize.SMALLER
            }),
        renderNextButton: ({ onClick, className: nextButtonClassName })=>/*#__PURE__*/ React.createElement(DefaultNextButton, {
                onClick: onClick,
                className: c(nextButtonClassName, s['next-button']),
                arrowSize: IconSize.SMALLER
            }),
        permArrows: true,
        noSpacing: true
    }), facets);
};
FacetListRow.displayName = 'FacetListRow';
export default FacetListRow;

//# sourceMappingURL=FacetListRow.js.map